module.exports = __webpack_public_path__ + "img/electric.174c4d42.png";